import React, { useEffect } from "react";
import { Card, Table, Layout, Input, Form, Space, Tag, Col } from "antd";
import { BankOutlined, WalletOutlined } from "@ant-design/icons";
import { Link, useHistory, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { orgsStore } from "../../store/org/OrgsStore2";
import { GradeRange } from "../../components/GradeRange";
import { RegionFilterBar } from "../../components/filter/RegionFilterBar";

export const Orgs = observer(() => {
  const store = orgsStore;

  const location = useLocation();

  const history = useHistory();

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Org Name",
      dataIndex: "name",
      key: "nama",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (t, r) => (
        <Space>
          <Link to={`/orgs/${r.id}/members`}>{t}</Link>
          {r.isSchool && (
            <Tag icon={<BankOutlined />} color="blue">
              School
            </Tag>
          )}
          {r.canFund && (
            <Tag icon={<WalletOutlined />} color="gold">
              Fundraising
            </Tag>
          )}
        </Space>
      ),
    },
    {
      title: "Community Name",
      dataIndex: ["community", "name"],
      key: "community",
    },
    {
      title: "Grades",
      dataIndex: "grades",
      key: "grades",
      render: (_, r) => GradeRange(r),
    },
    // {
    //   title: "Active User Count",
    //   dataIndex: "activeUserCount",
    //   sorter: (a, b) => a.activeUserCount - b.activeUserCount,
    //   key: "count",
    // },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      sorter: (a, b) => a.city.localeCompare(b.city),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: (a, b) => a.state.localeCompare(b.state),
    },
    // {
    //   title: "Notes",
    //   width: "30%",
    //   dataIndex: "description",
    //   key: "description",
    //   sorter: (a, b) => (a.description || "").localeCompare(b.description),
    // },
    {
      title: "",
      key: "opt",
      // render: (t, r) => (Store.isDivision ? null : <EditOutlined onClick={() => store.orgEdit.edit(r.id)} />),
    },
  ];
  return (
    <Layout.Content className="padding24">
      {/* <Toolbar
        actions={
          Store.isDivision ? null : (
            <Button type="primary" size="large" icon={<PlusOutlined />} onClick={() => store.edit.new()}>
              New Org
            </Button>
          )
        }
      ></Toolbar> */}

      <RegionFilterBar store={store} actionsSpan={16}>
        <Col span={8}>
          <Form.Item label="Org Name">
            <Input
              value={store.filter.keyword}
              onChange={(e) => (store.filter.keyword = e.target.value)}
              placeholder="Search by name"
            />
          </Form.Item>
        </Col>
      </RegionFilterBar>

      <Card size="small">
        <Table
          size="small"
          rowKey="id"
          columns={columns}
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          dataSource={store.items}
        />
      </Card>
    </Layout.Content>
  );
});
